import React from "react";
import { engineStatus } from "./copData";
import logo from "../../images/Upsellit-logo-WhiteText-500w-transparent.png";

const NAV = [
	{ key: "command-center", label: "Command Center", ico: "◈" },
	{ key: "clustering", label: "Clustering Studio", ico: "✣" },
	{ key: "builder", label: "Campaign Builder", ico: "▣" },
	{ key: "experiment-lab", label: "Experiment Lab", ico: "⚗" },
	{ key: "exit-intelligence", label: "Exit Intelligence", ico: "⎋" },
	{ key: "reporting", label: "Intelligence Reporting", ico: "◫" },
	{ key: "deep-research", label: "Deep Research", ico: "◬" }
];

const GOV = [
	{ key: "approvals", label: "Approval Queue", ico: "✓" },
	{ key: "suppressions", label: "Global Suppressions", ico: "⊘" },
	{ key: "audit-log", label: "Audit Log", ico: "☰" }
];

const SUPPORT = [
	{ key: "settings", label: "Settings", ico: "⚙" },
	{ key: "help", label: "Help & Concepts", ico: "?" }
];

const TONE_COLOR = { green: "var(--green)", cyan: "var(--cyan)", amber: "var(--amber)" };

export default function CopSidebar({ view, onNavigate, pendingCount, viewMode, onSetViewMode, open, onClose }) {
	const isInternal = viewMode === "internal";

	const renderItems = (items) =>
		items.map((item) => (
			<button
				key={item.key}
				className={`cop-nav-item${view === item.key ? " active" : ""}`}
				onClick={() => onNavigate(item.key)}
			>
				<span className="cop-nav-ico">{item.ico}</span>
				{item.label}
				{item.key === "approvals" && pendingCount > 0 && <span className="cop-nav-badge">{pendingCount}</span>}
			</button>
		));

	return (
		<>
			<div className={`cop-sidebar-backdrop${open ? " open" : ""}`} onClick={onClose} />
			<aside className={`cop-sidebar${open ? " open" : ""}`}>
			<button type="button" className="cop-sidebar-close" onClick={onClose} aria-label="Close navigation menu">✕</button>
			<button type="button" className="cop-logo" onClick={() => onNavigate("home")} aria-label="Go to home">
				<img src={logo} alt="Upsellit" className="cop-logo-img" />
				<span className="cop-logo-sub">Campaign Optimization</span>
			</button>

			<div className="cop-nav-label">Platform</div>
			{renderItems(NAV)}

			<div className="cop-nav-label">Governance</div>
			{renderItems(GOV)}

			<div className="cop-nav-label">Support</div>
			{renderItems(SUPPORT)}

			<div className="cop-view-toggle cop-internal">
				{isInternal && (
					<div className="cop-engine-status">
						{engineStatus.map((e) => (
							<div className="cop-engine-row" key={e.label}>
								<span>{e.label}</span>
								<span className="cop-engine-state" style={{ color: TONE_COLOR[e.tone] }}>
									<span style={{ fontSize: 7 }}>●</span> {e.state}
								</span>
							</div>
						))}
					</div>
				)}
				<div className="cop-view-seg" role="group" aria-label="View mode">
					<button className={isInternal ? "active internal" : ""} onClick={() => onSetViewMode("internal")}>
						⚙ Internal View
					</button>
					<button className={!isInternal ? "active client" : ""} onClick={() => onSetViewMode("client")}>
						◉ Client View
					</button>
				</div>
				{/* <div className="cop-view-hint">
					{isInternal
						? 'Ops telemetry, warnings, and AOP links are visible in amber internal cards.'
						: 'Previewing exactly what the client sees in Client Reporting.'}
				</div> */}
			</div>
			</aside>
		</>
	);
}
